












































































































































































































































import {Component} from 'vue-property-decorator'
import NetworkTag from '@/components/NetworkTag.vue'
import OrbitLearnMoreModal from '@/components/orbit/OrbitLearnMoreModal.vue'
import AppFooter from '@/components/footer/AppFooter.vue'
import OrbitTokenCarousel from '@/components/orbit/OrbitTokenCarousel.vue'
import {TextHelper} from '@/helpers/TextHelper'
import {MixinScreenSize} from '@/components/mixins/MixinScreenSize'
import OrbitCardCarousel from '@/components/orbit/OrbitCardCarousel.vue'
import {OrbitHelper} from '@/helpers/OrbitHelper'
import {OrbitProjectCollection} from '@/model/collection/OrbitProjectCollection'

@Component({
  computed: {
    TextHelper() {
      return TextHelper
    },
  },
  components: {
    OrbitCardCarousel,
    OrbitTokenCarousel,
    AppFooter,
    OrbitLearnMoreModal,
    NetworkTag,
  },
})
export default class OrbitHomeView extends MixinScreenSize {
  isLearnMoreModalVisible = false

  activeRound = 0
  lastRound = 0
  currentRoundDisplayed = 0
  hasRound = false

  orbitProjectCollection = new OrbitProjectCollection()

  mounted() {
    this.populateResources()
  }

  async populateResources() {
    this.$await.init('populateOrbitContracts')

    this.orbitProjectCollection.active = true

    this.activeRound = Number(await OrbitHelper.getActiveRound()) || 0
    this.lastRound = Number(await OrbitHelper.getLastRound())

    if (this.activeRound === 0) {
      this.currentRoundDisplayed = this.lastRound
      this.orbitProjectCollection.round = [this.lastRound]
    } else {
      this.currentRoundDisplayed = this.activeRound
      this.orbitProjectCollection.round = [this.activeRound]
    }

    if (this.activeRound === 0 && this.lastRound === 0) {
      this.hasRound = false
    } else {
      this.hasRound = true
    }

    await this.orbitProjectCollection.queryAsPage()

    this.$await.done('populateOrbitContracts')
  }

  handleOpenOrbitLearnMoreModal() {
    this.isLearnMoreModalVisible = true
  }

  closeLearnMoreModal() {
    this.isLearnMoreModalVisible = false
  }
}
